<template>
  <div>
    <Edit :editDialog="editDialog" @close="editDialog = false" @submit="getLead" :editLead="selectedLead"></Edit>
    <v-alert v-if="lead" border="left" type="error" tile transition="slide-y-transition" dismissible class="mb-2"
      v-model="lead.alert" color="red">
      <strong>{{ lead.note }}</strong>
    </v-alert>
    <v-card tile flat v-if="lead">
      <v-toolbar dense flat color="grey lighten-3">
        <v-app-bar-nav-icon @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>

        <v-toolbar-title class="text-capitalize">
          {{ lead.fatherName }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu bottom left offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon>
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list class="menu-button">
            <v-list-item v-if="checkRightStatus(44)" @click="editLead(lead)">
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="checkRightStatus(45)" @click="deleteLead(lead)">
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>

      <v-card-text>
        <v-row class="mt-5" v-if="!lead" align-center justify-center column fill-height>
          <v-progress-circular size="70" width="7" color="purple" indeterminate="indeterminate"></v-progress-circular>
          <div>Loading...</div>
        </v-row>
        <v-row row wrap v-else justify-space-between>
          <v-col shrink>
            <v-row>
              <v-col class="shrink">
                <v-img width="50" src="@/assets/islamic.png"></v-img>
              </v-col>
              <v-col>
                <div class="text-capitalize">
                  <span class="font-weight-medium">Contact Name: </span>
                  <span v-if="lead.fatherName">{{ lead.fatherName }}</span>
                  <span v-else>Not Set</span>
                </div>
                <div class="text-capitalize">
                  <span class="font-weight-medium">Phone Number: </span>
                  <span v-if="lead.fatherPhoneNumber">{{
                    lead.fatherPhoneNumber | USPhoneNumber
                    }}</span>
                  <span v-else>Not Set</span>
                </div>
                <div>
                  <span class="font-weight-medium">Email: </span>
                  <a v-if="lead.fatherEmailAddress" @click="sendEmail(lead.fatherEmailAddress)">{{
                    lead.fatherEmailAddress
                    }}</a>
                  <span v-else>Not Set</span>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="lead.motherName">
              <v-col class="shrink">
                <v-img width="50" src="@/assets/moroccan.png"></v-img>
              </v-col>
              <v-col>
                <div class="text-capitalize">
                  <span class="font-weight-medium">Contact Name: </span>
                  <span v-if="lead.motherName">{{ lead.motherName }}</span>
                  <span v-else>Not Set</span>
                </div>
                <div class="text-capitalize">
                  <span class="font-weight-medium">Phone Number: </span>
                  <span v-if="lead.motherPhoneNumber">{{
                    lead.motherPhoneNumber | USPhoneNumber
                    }}</span>
                  <span v-else>Not Set</span>
                </div>
                <div>
                  <span class="font-weight-medium">Email: </span>
                  <a v-if="lead.motherEmailAddress" @click="sendEmail(lead.motherEmailAddress)">{{
                    lead.motherEmailAddress
                    }}</a>
                  <span v-else>Not Set</span>
                </div>
              </v-col>
            </v-row>
            <v-chip v-if="lead.stripeId" class="ma-2" color="green" text-color="white">
              <v-avatar left>
                <v-icon>mdi-checkbox-marked-circle</v-icon>
              </v-avatar>
              Verified
            </v-chip>

          </v-col>
          <v-spacer></v-spacer>
          <v-col shrink>
            <div class="text-right">
              <v-tooltip bottom v-if="lead.address">
                <template v-slot:activator="{ on }">
                  <a v-on="on" @click="openGoogleMap">
                    <div class="text-capitalize title">
                      {{ lead.address }}
                    </div>
                    <div class="text-capitalize">
                      {{ lead.city }}, {{ lead.state }}
                      {{ lead.zip }}
                    </div>
                  </a>
                </template>
                <span>Click to open google map</span>
              </v-tooltip>

              <div class="mt-1">
                <span class="font-weight-medium">Created At: </span>
                <span>{{ lead.createdAt | moment("MM/DD/YYYY") }}</span>
              </div>

              <div class="mt-1 text-decoration-underline blue--text pointer" @click="viewProfile(lead.CustomerId)"
                v-if="lead.CustomerId">
                <span class="font-weight-medium">Open Parent Profile</span>
              </div>
              <!-- <div class="mt-1">
                <span class="font-weight-medium">Status: </span>
                <v-menu v-if="lead" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn :loading="statusLoading" small :color="statusColor(lead.status)" dark v-bind="attrs" v-on="on">
                      {{ lead.status }}
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="changeStatus(item)" v-for="(item, index) in leadStatus" :key="index">
                      <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div> -->
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <v-container grid-list-lg fluid>
      <v-layout v-if="lead && lead.emergencyName">
        <v-flex>
          <v-card outlined>
            <v-toolbar dense flat color="grey lighten-3">
              <v-toolbar-title>Emergency </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col>
                  <div class="text-decoration-underline">Name</div>
                  <div class="text-capitalize font-weight-medium">{{ lead.emergencyName }}</div>
                </v-col>
                <v-col>
                  <div class="text-decoration-underline">Contact Number</div>
                  <div class="text-capitalize font-weight-medium">{{ lead.emergencyPhoneNumber | USPhoneNumber }}</div>
                </v-col>
                <v-col>
                  <div class="text-decoration-underline">Relation</div>
                  <div class="text-capitalize font-weight-medium">{{ lead.emergencyRelation }}</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="lead && lead.LeadStudents.length !== 0">
        <v-flex xs12>
          <v-card outlined>
            <ListTitle :showBackButton="false" :access="lead.isChild" title="Students" @add="openAddStudentDialog" />

            <!-- <v-toolbar dense flat color="grey lighten-3">
              <v-toolbar-title>Students </v-toolbar-title>
            </v-toolbar> -->
            <v-card-text>
              <v-data-table :headers="headers" hide-default-footer :items="lead.LeadStudents" :loading="loading"
                :expanded.sync="expanded" show-expand :items-per-page="20">
                <template v-slot:item="{ item, isExpanded, expand }">
                  <tr class="pointer">
                    <td class="text-left">
                      <v-btn @click="expand(true)" icon v-if="!isExpanded"><v-icon>mdi-chevron-down</v-icon></v-btn>
                      <v-btn @click="expand(false)" icon v-if="isExpanded"><v-icon>mdi-chevron-up</v-icon></v-btn>
                    </td>
                    <td class="text-left">{{ item.localId }}</td>
                    <td class="text-left text-capitalize">
                      {{ item.fullName }}
                    </td>
                    <td>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <span v-on="on">
                            {{ getAge(item.dob) }}</span>
                        </template>
                        <span> {{ item.dob | moment("L") }}</span>
                      </v-tooltip>
                    </td>
                    <td class="text-left">
                      <span v-if="item.Class">{{ item.Class.name }}</span>
                      <span v-else>Not Selected</span>
                    </td>
                    <td>
                      <div>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn :loading="statusLoading" small :color="statusColor(item.status)" dark v-bind="attrs"
                              v-on="on">
                              {{ item.status }}
                            </v-btn>
                          </template>

                          <v-list>
                            <v-list-item @click="changeStatus(status, item)" v-for="(status, index) in leadStatus"
                              :key="index">
                              <v-list-item-title>{{ status }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>

                    </td>
                    <td class="justify-end align-center text-right">
                      <v-menu bottom left offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" icon>
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                        </template>
                        <v-list class="menu-button">

                          <v-list-item @click="editStudent(item)">
                            <v-list-item-title>Edit</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="deleteStudent(item)">
                            <v-list-item-title>Delete</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="pa-0">
                    <v-card dark class="ma-3">
                      <v-card-text>
                        <v-row>
                          <v-col cols="6" v-for="(detail, idx) in item.metadata" :key="idx">
                            <h2 class="text-capitalize font-weight-regular subtitle-2">Q: {{ detail.question }}</h2>
                            <div v-if="detail.selectedAnswerType === 'Checkboxes'">
                              <v-layout row wrap>
                                <v-flex shrink class="pr-0">
                                  A:
                                </v-flex>
                                <v-flex class="pl-0">
                                  <div v-if="detail && detail.ChoiceList">
                                    <div v-for="(list, index) in detail.ChoiceList" :key="index"
                                      class="font-weight-bold text-capitalize">
                                      <v-checkbox readonly v-model="list.answer" :key="index" :label="list.label"
                                        hide-details class="mt-0 shrink mx-0"></v-checkbox>
                                    </div>
                                  </div>
                                </v-flex>
                              </v-layout>
                            </div>
                            <div v-if="detail.selectedAnswerType === 'Multiple choice'">
                              <v-layout row wrap>
                                <v-flex shrink class="pr-0">
                                  A:
                                </v-flex>
                                <v-flex class="pl-0">
                                  <v-radio-group readonly v-model="detail.answer" v-if="detail && detail.ChoiceList">
                                    <v-radio v-for="(list, ind) in detail.ChoiceList" v-model="list.answer" :key="ind"
                                      :label="list.label" hide-details class="mt-0 shrink mx-0"
                                      :value="list.answer"></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                            </div>
                            <p v-if="detail.selectedAnswerType === 'Short answer'"
                              class="font-weight-bold text-capitalize">A: {{ detail.answer }}</p>
                            <p v-if="detail.selectedAnswerType === 'Dropdown'"
                              class="font-weight-bold text-capitalize">A: {{ detail.answer }}</p>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </td>
                </template>
                <!-- <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found
              no results.</v-alert> -->

              </v-data-table>
            </v-card-text>
          </v-card>

        </v-flex>
      </v-layout>
      <v-layout row wrap>
      
        <v-flex xs12 v-if="lead">
          <Comment :RelationId="lead" :TypeId="2" />
        </v-flex>
      </v-layout>
    </v-container>
    
    <v-dialog v-model="editStudentDialog" width="500">


      <v-card>
        <ModelTitle title="Edit Student" @close="closeEditDialog" />

        <v-card-text v-if="Student">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field outlined dense :background-color="`${Student.firstName ? false : '#E8F5E9'}`"
                :error-messages="studentFirstNameErrors" :hide-details="studentFirstNameErrors.length === 0
                  " autofocus v-model="Student.firstName" label="First Name"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field outlined :background-color="`${Student.lastName ? false : '#E8F5E9'}`"
                :error-messages="studentLastNameErrors" :hide-details="studentLastNameErrors.length === 0
                  " dense v-model="Student.lastName" label="Last Name"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select dense :background-color="`${Student.gender ? false : '#E8F5E9'}`" :error-messages="genderErrors"
                :hide-details="genderErrors.length === 0" :items="['male', 'female']" label="Gender"
                v-model="Student.gender" outlined>
              </v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field outlined dense :background-color="`${Student.dob ? false : '#E8F5E9'}`"
                :error-messages="dobError" :hide-details="dobError.length === 0" type="date" v-model="Student.dob"
                label="Date of Birth"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-autocomplete dense :items="Classes" :background-color="`${Student.selectedClass ? false : '#E8F5E9'}`"
                clearable item-text="name" :error-messages="classIdErrors" :hide-details="classIdErrors.length === 0"
                v-model="Student.selectedClass" return-object label="Select Department" outlined>
                <template slot="item" slot-scope="{ item }">
                  <span>{{ item.name }}</span>
                  <v-spacer></v-spacer>
                  <span>{{
                    item.defaultFee | currency
                    }}</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text>
          <div class="text-center">
            {{ Student.firstName }} {{ Student.lastName }}
            <span v-if="Student.dob">is {{ getAge(Student.dob) }} year old</span>
          </div>
          <div v-if="getAge(Student.dob) < 5" class="red--text text-center">
            Minimum age of admission is 6 year
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" :disabled="getAge(Student.dob) > 4 ? false : true
            " block @click="saveStudent">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addStudentDialog" width="500">

      <v-card>
        <ModelTitle title="Add Student" @close="closeAddStudentDialog" />

        <v-card-text v-if="Student">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field outlined dense :background-color="`${Student.firstName ? false : '#E8F5E9'}`"
                :error-messages="studentFirstNameErrors" :hide-details="studentFirstNameErrors.length === 0
                  " autofocus v-model="Student.firstName" label="First Name"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field outlined :background-color="`${Student.lastName ? false : '#E8F5E9'}`"
                :error-messages="studentLastNameErrors" :hide-details="studentLastNameErrors.length === 0
                  " dense v-model="Student.lastName" label="Last Name"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select dense :background-color="`${Student.gender ? false : '#E8F5E9'}`" :error-messages="genderErrors"
                :hide-details="genderErrors.length === 0" :items="['male', 'female']" label="Gender"
                v-model="Student.gender" outlined>
              </v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field outlined dense :background-color="`${Student.dob ? false : '#E8F5E9'}`"
                :error-messages="dobError" :hide-details="dobError.length === 0" type="date" v-model="Student.dob"
                label="Date of Birth"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-autocomplete dense :items="Classes" :background-color="`${Student.selectedClass ? false : '#E8F5E9'}`"
                clearable item-text="name" :error-messages="classIdErrors" :hide-details="classIdErrors.length === 0"
                v-model="Student.selectedClass" return-object label="Select Department" outlined>
                <template slot="item" slot-scope="{ item }">
                  <span>{{ item.name }}</span>
                  <v-spacer></v-spacer>
                  <span>{{
                    item.defaultFee | currency
                    }}</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text>
          <div class="text-center">
            {{ Student.firstName }} {{ Student.lastName }}
            <span v-if="Student.dob">is {{ getAge(Student.dob) }} year old</span>
          </div>
          <div v-if="getAge(Student.dob) < 5" class="red--text text-center">
            Minimum age of admission is 6 year
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" :disabled="getAge(Student.dob) > 4 ? false : true
            " block @click="addStudent">
            Add Student
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import applicationService from "../service";
import Comment from "@/modules/Comment/components/List";
import { mapGetters } from "vuex";
const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");
const Edit = () => import("../components/Edit");
import GlobalFunction from "@/mixins/GlobalFunction";
import classService from "@/modules/Classes/service.js";

export default {
  name: "laed-profile",
  data() {
    return {
      expanded: [],
      singleExpand: false,
      addStudentDialog: false,
      Student: {
        firstName: null,
        lastName: null,
        dob: null,
        selectedClass: null,
        ClassId: null,
      },
      Classes: [],
      editStudentDialog: false,
      leadStatus: ["Open", "Contacted", "Waiting", "Closed", "Ready to join", "Convert"],
      loading: false,
      statusLoading: false,
      editDialog: false,
      lead: null,
      selectedLead: null,
      note: null,
      headers: [
        {
          text: 'ID',
          align: "left",
          value: "localId",
          sortable: true,
        }, {
          text: 'Name',
          align: "left",
          value: "fullName",
          sortable: true,
        },
        {
          text: 'Age',
          align: "left",
          value: "name",
          sortable: true,
        }, {
          text: 'Class Name',
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: 'Status',
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        }
      ],
    };
  },
  created() {
    this.getLead();
    this.$events.listen("applicationProfileEvent", () => {
      this.getLead();
    });
  },
  beforeDestroy() {
    this.$events.remove("applicationProfileEvent");
  },
  // watch: {
  //   editStudentDialog(val) {
  //     if (val) {
  //       this.getClassList()
  //     }
  //   }
  // },
  components: {
    Comment,
    Edit,
  },
  mixins: [validationMixin, GlobalFunction],
  validations: {
    Student: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      dob: {
        required,
      },
      gender: {
        required,
      },
      selectedClass: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    genderErrors() {
      const errors = [];
      if (!this.$v.Student.gender.$dirty) return errors;
      if (!this.$v.Student.gender.required) errors.push("Gender is required");

      return errors;
    },
    studentFirstNameErrors() {
      const errors = [];
      if (!this.$v.Student.firstName.$dirty) return errors;
      if (!this.$v.Student.firstName.required)
        errors.push("First Name is required");
      return errors;
    },
    studentLastNameErrors() {
      const errors = [];
      if (!this.$v.Student.lastName.$dirty) return errors;
      if (!this.$v.Student.lastName.required)
        errors.push("Last Name is required");
      return errors;
    },
    dobError() {
      const errors = [];
      if (!this.$v.Student.dob.$dirty) return errors;
      if (!this.$v.Student.dob.required)
        errors.push("Date of birth is required");
      return errors;
    },
    classIdErrors() {
      const errors = [];
      if (!this.$v.Student.selectedClass.$dirty) return errors;
      if (!this.$v.Student.selectedClass.required)
        errors.push("Class is required");
      // if (!this.$v.Product.selectedClass.minValue) errors.push("Please Select Department");

      return errors;
    },
  },
  methods: {
    openAddStudentDialog() {
      this.getClassList()
      this.addStudentDialog = !this.addStudentDialog
    },
    addStudent() {
      console.log('student added')
      this.$v.Student.$touch();
      if (this.$v.Student.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });

      } else {
        this.Student.LeadId = this.lead.id
        if (this.Student && this.Student.selectedClass) {
          this.Student.ClassId = this.Student.selectedClass.id
        }
        applicationService.addLeadStudent(this.Student)
          .then(result => {
            console.log('update result', result)
            this.emptyStudent()
            this.addStudentDialog = !this.addStudentDialog
            this.getLead();
          })
      }

    },
    saveStudent() {
      console.log('item', this.Student)
      this.$v.Student.$touch();
      if (this.$v.Student.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
        return false
      } else {
        this.Student.ClassId = this.Student.selectedClass.id
        applicationService.updateLeadStudent(this.Student.id, this.Student)
          .then(result => {
            console.log('update result', result)
            this.emptyStudent()
            this.editStudentDialog = !this.editStudentDialog
            this.getLead();
          })
      }

    },
    getClassList() {
      return classService.getAll().then((response) => {
        console.log("response", response);
        this.loading = false;
        this.Classes = response.data;
        this.Classes.map(row => {
          if (row.id === this.Student.ClassId) {
            this.Student.selectedClass = row
          }
        })
        return response;
      });
    },
    emptyStudent() {
      this.Student = {
        firstName: null,
        lastName: null,
        dob: null,
        selectedClass: null,
        ClassId: null,
      }
    },
    closeEditDialog() {
      this.emptyStudent()
      this.editStudentDialog = !this.editStudentDialog
    },
    closeAddStudentDialog() {
      this.emptyStudent()
      this.addStudentDialog = !this.addStudentDialog
    },
    editStudent(item) {
      this.getClassList()
      this.editStudentDialog = !this.editStudentDialog
      this.Student = JSON.parse(JSON.stringify(item))
      this.Student.dob = this.Student.dob.split("T")[0]
      // this.Student.dob = bDate[0]
      // console.log('dob', bDate)
      // console.log('dob', dobDate.getDay())
      console.log('item', this.Student)
    },
    viewProfile(id) {
      this.$router.push({ path: `/parents/${id}/profile` });
    },
    statusColor(status) {
      let color = 'green'
      switch (status) {
        case 'Open':
          color = '#1976D2'
          break;
        case 'Contacted':
          color = '#6A1B9A'
          break;
        case 'Closed':
          color = 'red'
          break;
        case 'Waiting':
          color = '#AED581'
          break;

        case 'Convert':
          color = 'green'
          break;
        case 'Ready to join':
          color = '#00BFA5'
          break;
        default:
          color = 'green'
      }

      return color
    },
    changeStatus(status, studentLead) {
      // this.statusLoading = true
      console.log('val', status, studentLead)
      if (status === 'Convert') {
        this.$swal({
          title: "Are you sure?",
          text: `You want to convert ${studentLead.fullName}. You won't be able to revert this!`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#B71C1C",
          cancelButtonColor: "#43A047",
          cancelButtonText: "No",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            if (studentLead.status !== status) {
              applicationService.convertLead(studentLead.id, {})
                .then(result => {
                  console.log('lead update', result)
                  this.statusLoading = false
                  studentLead.status = status
                  this.getLead()
                }).catch(err => {
                  console.log('err', err)
                  this.$swal
                    .mixin({
                      toast: true,
                      position: "top-end",
                      showConfirmButton: false,
                      timer: 3000,
                    })
                    .fire({
                      icon: "error",
                      title: err.data.message,
                    });
                })
            }
          }
        });
      } else {
        if (studentLead.status !== status) {
          applicationService.leadStudentUpdate(studentLead.id, { status: status })
            .then(result => {
              console.log('lead update', result)
              this.statusLoading = false
              studentLead.status = status
            })
        }
      }


    },
    getAge(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    updateAlert(val) {
      let data = {
        alert: val.value,
      };
      this.updateLead(data);
    },
    openGoogleMap() {
      window.open(
        `https://www.google.com/maps/place/${this.lead.address} ${this.lead.city},${this.lead.state} ${this.lead.zip}`,
        "_blank"
      );
    },
    updateNote() {
      let data = {
        note: this.note,
      };
      this.updateLead(data);
    },
    updateLead(data) {
      return applicationService.update(this.lead.id, data).then(() => {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "success",
            title: "Update Successfully",
          });
        this.getLead();
      });
    },
    editLead(lead) {
      this.selectedLead = lead;
      this.editDialog = !this.editDialog;
    },
    deleteStudent(student) {
      console.log('studne', student)
      this.$swal({
        title: "Are you sure?",
        text: `You want to remove ${student.fullName} from this application?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          applicationService.deleteLeadStudent(student.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Student has been deleted.", "success");
              this.getLead()
            }
          });
        }
      });
    },
    deleteLead(lead) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          applicationService.delete(lead.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Lead has been deleted.", "success");
              this.$router.go(-1);
            }
          });
        }
      });
    },
    getLead() {
      const { id } = this.$route.params;
      this.lead = null
      return applicationService.getById(id).then((response) => {
        this.lead = response.data;
        this.note = this.lead.note;
      });
    },
  },
};
</script>

<style scoped></style>
